export const FALLBACK_AVATAR_GRADIENT =
  'linear-gradient(135deg, #6A6FF5 0%, #FF7A7A 100%)';

/** Deterministic, pleasant gradient derived from a wallet address. */
export const getAddressGradient = (address?: string) => {
  if (!address) return FALLBACK_AVATAR_GRADIENT;

  let hash = 0;
  for (let i = 2; i < address.length; i++) {
    hash = (hash * 31 + address.charCodeAt(i)) >>> 0;
  }
  const hue = hash % 360;
  const hue2 = (hue + 90) % 360;

  return `linear-gradient(135deg, hsl(${hue}, 68%, 62%), hsl(${hue2}, 72%, 58%))`;
};
